/** The Cognito group whose members may read the audit log (admin-assigned only). */
export const REVIEWER_GROUP = 'reviewer';

/**
 * Decide from a decoded ID token payload whether to show reviewer UI.
 *
 * Why: reviewer status is membership of the admin-assigned `reviewer` group (011, D1). The
 * legacy `custom:role` attribute was user-writable, so it is ignored. This only drives what
 * the UI shows — `/audit` enforces the same rule server-side.
 *
 * @param payload - The ID token's decoded claims.
 * @returns True when `cognito:groups` contains exactly `reviewer`.
 */
export function isReviewerFromIdTokenPayload(payload: Record<string, unknown>): boolean {
  const groups = payload['cognito:groups'];
  return Array.isArray(groups) && groups.includes(REVIEWER_GROUP);
}
